import { LitEntity, SirenActionMixin, html, css, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-flash';
import '../common/bn-form-field';
import '../common/bn-loading';

class ConfirmRegistrationAction extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      name: { type: String, attribute: false },
      password: { type: String, attribute: false },
      confirm: { type: String, attribute: false },
      submitting: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .title {
        margin-bottom: 2rem;
      }
      .info-text {
        margin-top: 2rem;
        margin-bottom: 1rem;
      }
      .hidden {
        display: none;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html``;
    }
    const disableSubmit = !this.name || !this.password || this.password !== this.confirm;
    return html`
      ${renderIf(this.submitting, html`
        <bn-loading><p>Creating account...</p></bn-loading>
      `)}
      <form @submit="${this._submit}" class="${this.submitting ? 'hidden' : ''}">
        <h3 class="title">Confirm Registration</h3>
        <bn-flash></bn-flash>

        <bn-form-field type="text" title="Email" readonly disabled value="${this.entity.properties.email}"></bn-form-field>
        
        <bn-form-field required type="text" name="name" title="Name" 
                       @keyup="${this._update}" 
                       @blur="${this._update}"
        ></bn-form-field>
        
        <div class="info-text">Choose a password. When signing in, you can use this password or sign in with your Google account.</div>
        <bn-form-field required type="password" name="password" title="Password" 
                       @keyup="${this._update}" 
                       @blur="${this._update}"
                       .validator="${this._validatePassword}"
        ></bn-form-field>
        <bn-form-field required type="password" name="confirm" title="Confirm Password" 
                       @keyup="${this._update}" 
                       @blur="${this._update}"
        ></bn-form-field>

        <div class="form-actions">
          <button class="button button--contained" ?disabled="${disableSubmit}" type="submit">Create Account</button>
        </div>
      </form>
    `;
  }

  updated(props) {
    super.updated(props);
    this._update();
  }

  _inputValue(name) {
    const field = this.shadowRoot.querySelector(`bn-form-field[name="${name}"]`);
    return field.input ? field.input.value : undefined;
  }

  _validatePassword(value) {
    if (value.length < 8) {
      return 'Password must be at least 8 characters long';
    }
  }

  _update(event) {
    if (!this.entity) {
      return;
    }
    this.name = this._inputValue('name');
    this.password = this._inputValue('password');
    this.confirm = this._inputValue('confirm');

    const confirmField = this.shadowRoot.querySelector('bn-form-field[name="confirm"]');
    confirmField.currentError = this.confirm !== this.password ? 'Passwords don\'t match' : '';

    const submitButton = this.shadowRoot.querySelector('button[type="submit"]');
    if (event && event.key === 'Enter' && !submitButton.disabled) {
      submitButton.click();
    }
  }

  async _submit(e) {
    e.preventDefault();
    this.submitting = true;
    const action = this.entity.getActionByName('confirm-registration');
    if (!action) {
      return;
    }
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    try {
      const fields = this.getActionFields(action);
      fields.set('name', this.name);
      fields.set('password', this.password);
      const { entity, response, error } = await this.submitAction(action, fields);
      if (error) {
        throw new Error(error);
      }
      this.dispatchEvent(new CustomEvent('response', { detail: { entity, response }, bubbles: true, composed: true }));
    } catch (error) {
      flash.critical(html`Could not create account.<br/><code>${error.message}</code>`);
    } finally {
      this.submitting = false;
    }
  }
}

window.customElements.define('confirm-registration-action', ConfirmRegistrationAction);
